/* SELL CGM — ad landing page: live payout builder → confirm → quote form. Pairs with sections/scgm-sell-landing.liquid. */
(function () {
  'use strict';

  var root = document.getElementById('scgm-sell');
  if (!root) return;

  var STORAGE_KEY = 'scgm_quote_v1'; // same basket scgm-quote.js reads on the quote page
  var MAX_QTY = 200;
  var QUOTE_PAGE = root.dataset.quotePage || '/pages/request-for-quote';
  var BONUS_MIN = (parseFloat(root.dataset.bonusMinimum) || 250) * 100;
  var BONUS_AMT = (parseFloat(root.dataset.bonusAmount) || 20) * 100;

  var data;
  try { data = JSON.parse(root.querySelector('[data-ss-data]').textContent); } catch (e) { return; }
  var catalog = {};
  data.items.forEach(function (it) { catalog[it.key] = it; });

  /** Step tracking lives in scgm-quote.js (window.SCGMTrack); no-op if it hasn't loaded. */
  function track(name, params, opts) {
    try { if (window.SCGMTrack) window.SCGMTrack(name, params, opts); } catch (e) {}
  }

  var state = {}; // key -> { v: variant index, qty }
  var started = false;
  var lastKey = null; // the product the visitor touched last: the docked phone receipt shows its line
  var prevBoxes = 0;

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var els = {
    lines: $('[data-ss-lines]'),
    empty: $('[data-ss-empty]'),
    total: $('[data-ss-total]'),
    receipt: $('[data-ss-receipt]'),
    bonus: $('[data-ss-bonus]'),
    bonusFill: $('[data-ss-bonus-fill]'),
    bonusText: $('[data-ss-bonus-text]'),
    ctas: $$('[data-ss-cta]'),
    ctaLabel: $('[data-ss-cta-label]'),
    bar: $('[data-ss-bar]'),
    barAmount: $('[data-ss-bar-amount]'),
    sheet: $('[data-ss-sheet]'),
    checks: $('[data-ss-checks]'),
    sheetRef: $('[data-ss-sheet-ref]'),
    sheetTotal: $('[data-ss-sheet-total]'),
    headline: $('[data-ss-headline]'),
    dock: $('[data-ss-dock]'),
    toggle: $('[data-ss-toggle]'),
    toggleLabel: $('[data-ss-toggle-label]'),
  };

  function money(cents) {
    var d = Math.round(cents) / 100;
    return '$' + (d % 1 ? d.toFixed(2) : d.toLocaleString('en-US'));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function variantLabel(title) {
    if (/Expires/.test(title) && /\//.test(title)) return title;
    return title.split(' – ').pop();
  }

  function lines() {
    return Object.keys(state).filter(function (k) { return state[k].qty > 0 && catalog[k]; }).map(function (k) {
      var it = catalog[k];
      var v = it.variants[state[k].v] || it.variants[0];
      return { key: k, item: it, variant: v, qty: state[k].qty, total: v.price * state[k].qty };
    });
  }
  function subtotal() { return lines().reduce(function (s, l) { return s + l.total; }, 0); }

  /* ---------- animated total ---------- */
  var shown = 0, animFrom = 0, animTo = 0, animStart = 0, raf = 0;
  function animateTotal(to) {
    animFrom = shown; animTo = to; animStart = performance.now();
    cancelAnimationFrame(raf);
    var step = function (now) {
      var t = Math.min(1, (now - animStart) / 550);
      var eased = 1 - Math.pow(1 - t, 3);
      shown = animFrom + (animTo - animFrom) * eased;
      var txt = money(Math.round(shown / 100) * 100);
      els.total.textContent = txt;
      els.barAmount.textContent = txt;
      if (t < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
  }

  /* ---------- render ---------- */
  function render() {
    var ls = lines();
    var sub = subtotal();
    var boxes = ls.reduce(function (n, l) { return n + l.qty; }, 0);

    els.empty.hidden = ls.length > 0;
    $$('.ss-line', els.lines).forEach(function (n) { n.remove(); });
    var latest = ls.some(function (l) { return l.key === lastKey; }) ? lastKey : (ls.length ? ls[ls.length - 1].key : null);
    ls.forEach(function (l) {
      var row = document.createElement('div');
      row.className = 'ss-line' + (l.key === latest ? ' is-latest' : '');
      row.innerHTML =
        '<span class="ss-line__name">' + l.qty + ' × ' + esc(l.item.name) + '</span>' +
        '<span class="ss-line__amt">' + money(l.total) + '</span>' +
        '<span class="ss-line__meta">' + esc(variantLabel(l.variant.title)) + ' · ' + money(l.variant.price) + ' each</span>';
      els.lines.appendChild(row);
    });

    animateTotal(sub);
    els.receipt.classList.toggle('is-live', sub > 0);
    els.bar.classList.toggle('is-up', sub > 0);
    els.bar.setAttribute('aria-hidden', sub > 0 ? 'false' : 'true');
    els.ctas.forEach(function (b) { b.disabled = sub === 0; b.tabIndex = sub > 0 ? 0 : -1; });
    els.ctaLabel.textContent = sub > 0 ? 'Lock in my ' + money(sub) + ' quote' : 'Add a box to start';

    // New-seller bonus nudge (the Worker decides eligibility; this only shows the rule).
    els.bonus.hidden = sub === 0;
    if (sub > 0) {
      var pct = Math.min(100, (sub / BONUS_MIN) * 100);
      els.bonusFill.style.width = pct + '%';
      els.bonusText.innerHTML = sub >= BONUS_MIN
        ? '<b>+' + money(BONUS_AMT) + ' new-seller bonus unlocked</b> on your first order.'
        : 'Add <b>' + money(BONUS_MIN - sub) + '</b> more to unlock a <b>' + money(BONUS_AMT) + '</b> first-order bonus.';
    }

    $$('[data-ss-item]').forEach(function (li) {
      var s = state[li.dataset.key];
      var q = s ? s.qty : 0;
      li.classList.toggle('is-on', q > 0);
      $('[data-ss-n]', li).textContent = q;
      $('[data-step="-1"]', li).disabled = q === 0;
      $('[data-ss-more]', li).hidden = q === 0;
    });
    root.dataset.boxes = boxes;

    // Phones: the receipt is docked to the bottom of the screen. Show it once there's a box, and "print" on each add.
    root.classList.toggle('has-items', sub > 0);
    if (sub === 0) setDock(false);
    if (els.toggleLabel) {
      els.toggleLabel.textContent = isDockOpen()
        ? 'Hide receipt'
        : 'Receipt \u00b7 ' + boxes + (boxes === 1 ? ' box' : ' boxes');
    }
    if (boxes > prevBoxes && prevBoxes > 0) {
      els.receipt.classList.remove('is-print');
      void els.receipt.offsetWidth; // restart the animation
      els.receipt.classList.add('is-print');
    }
    prevBoxes = boxes;
  }

  /* ---------- docked receipt (phones) ---------- */
  function isDockOpen() { return !!(els.dock && els.dock.classList.contains('is-open')); }
  function setDock(open) {
    if (!els.dock) return;
    els.dock.classList.toggle('is-open', open);
    if (els.toggle) els.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) { var paper = $('.ss-receipt__paper'); if (paper) paper.scrollTop = 0; }
  }

  function setQty(key, qty) {
    if (!catalog[key]) return;
    var s = state[key] || (state[key] = { v: 0, qty: 0 });
    s.qty = Math.max(0, Math.min(MAX_QTY, qty));
    lastKey = key;
    if (s.qty > 0 && !started) {
      started = true;
      track('QuoteBuilderStart', { content_name: catalog[key].name, value: subtotal() / 100, currency: 'USD' }, { once: 'builder' });
    }
    render();
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-step]');
    var chip = e.target.closest('[data-ss-variant]');
    var help = e.target.closest('[data-ss-ref-help]');
    var li = e.target.closest('[data-ss-item]');

    if (stepBtn && li) {
      var key = li.dataset.key;
      var cur = state[key] ? state[key].qty : 0;
      setQty(key, cur + parseInt(stepBtn.dataset.step, 10));
      return;
    }
    if (chip && li) {
      var k = li.dataset.key;
      (state[k] || (state[k] = { v: 0, qty: 1 })).v = parseInt(chip.dataset.ssVariant, 10);
      lastKey = k;
      $$('[data-ss-variant]', li).forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      render();
      return;
    }
    if (help) {
      openSheet(null, help.dataset.ssRefHelp, help.dataset.ssRefName);
      return;
    }
    if (e.target.closest('[data-ss-cta]')) {
      if (subtotal() > 0) { setDock(false); openSheet(lines()); }
      return;
    }
    if (e.target.closest('[data-ss-toggle]') || (e.target === els.dock && isDockOpen())) {
      setDock(!isDockOpen());
      render();
      return;
    }
    if (e.target.closest('[data-ss-chat]')) {
      var launcher = document.querySelector('.scgm-bot__launcher');
      if (launcher) launcher.click();
      else window.location.href = 'tel:+19108073468';
      return;
    }
    if (e.target.closest('[data-ss-bar-total]')) {
      els.receipt.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (e.target.closest('[data-ss-jump]')) {
      e.preventDefault();
      $('.ss-builder').scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (e.target.closest('[data-ss-close]')) { closeSheet(); return; }
    if (e.target.closest('[data-ss-confirm]')) { confirm(); }
  });

  /* ---------- confirm sheet ---------- */
  var lastFocus = null;
  function openSheet(ls, onlyRefImage, refName) {
    lastFocus = document.activeElement;
    var checks = [];
    if (ls) {
      checks.push('<b>Factory-sealed</b> and never opened');
      checks.push('<b>Mint condition</b>: no dents, dings, writing, adhesive residue, crushing, tears or water damage');
      checks.push('<b>Expiration</b> matches what you picked (' + ls.map(function (l) { return esc(l.item.name) + ': ' + esc(variantLabel(l.variant.title)); }).join('; ') + ')');
      ls.forEach(function (l) {
        if (l.item.refGood) {
          checks.push('<b>' + esc(l.item.name) + '</b> REF code reads <code>' + esc(l.item.refGood) + '</code>' +
            (l.item.refImage ? '<button type="button" class="ss-link" data-ss-sheet-img="' + esc(l.item.refImage) + '">Show me</button>' : ''));
        }
      });
      els.checks.innerHTML = checks.map(function (c) { return '<li><span>' + c + '</span></li>'; }).join('');
      els.sheetTotal.textContent = money(subtotal());
      $('[data-ss-confirm]').hidden = false;
      $('#ss-sheet-title').textContent = 'Do your boxes match?';
      els.sheetRef.hidden = true;
      track('ReviewQuote', { value: subtotal() / 100, currency: 'USD', num_items: ls.length });
    } else {
      els.checks.innerHTML = '';
      $('[data-ss-confirm]').hidden = true;
      $('#ss-sheet-title').textContent = 'Find the REF code' + (refName ? ' — ' + refName : '');
      showRef(onlyRefImage);
    }
    els.sheet.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var x = $('.ss-sheet__x');
    if (x) x.focus();
  }
  function showRef(src) {
    els.sheetRef.innerHTML = '<p class="ss-item__label">The REF code is printed on the side of the box, next to the expiration date.</p><img src="' + esc(src) + '" alt="Where to find the REF code on the box" loading="lazy">';
    els.sheetRef.hidden = false;
  }
  function closeSheet() {
    els.sheet.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  els.sheet.addEventListener('click', function (e) {
    var img = e.target.closest('[data-ss-sheet-img]');
    if (img) showRef(img.dataset.ssSheetImg);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!els.sheet.hidden) closeSheet();
    else if (isDockOpen()) { setDock(false); render(); }
  });

  function readBasket() {
    try { var b = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); return Array.isArray(b) ? b : []; } catch (e) { return []; }
  }

  function confirm() {
    var ls = lines();
    if (!ls.length) return;
    var basket = readBasket();
    ls.forEach(function (l) {
      var id = String(l.variant.id);
      var existing = basket.filter(function (i) { return i.variant_id === id; })[0];
      if (existing) existing.quantity = Math.min(MAX_QTY, existing.quantity + l.qty);
      else basket.push({
        variant_id: id,
        handle: l.item.handle,
        title: l.item.title,
        variant_title: l.variant.title === 'Default Title' ? '' : l.variant.title,
        sku: l.variant.sku || '',
        price: l.variant.price, // cents; display only — the Worker re-prices on submit
        image: l.item.image || '',
        quantity: l.qty,
      });
      // The seller just confirmed the REF code, so the product page's REF check counts as passed too.
      if (l.item.gateKey) { try { sessionStorage.setItem(l.item.gateKey, 'good'); } catch (e) {} }
    });
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(basket)); } catch (e) {}

    track('AddToQuote', {
      value: subtotal() / 100,
      currency: 'USD',
      num_items: ls.reduce(function (n, l) { return n + l.qty; }, 0),
      content_name: ls.map(function (l) { return l.item.name; }).join(', '),
      source: 'landing',
    });

    var btn = $('[data-ss-confirm]');
    btn.disabled = true;
    btn.querySelector('span').textContent = 'Locking it in…';
    // Give the pixels a moment to send before we leave the page.
    setTimeout(function () { window.location.href = QUOTE_PAGE; }, 350);
  }

  /* ---------- ad preload: /pages/sell?p=<key> ---------- */
  function preload() {
    var key = new URLSearchParams(location.search).get('p');
    if (!key || !catalog[key]) return;
    var li = $('[data-ss-item][data-key="' + CSS.escape(key) + '"]');
    if (!li) return;
    li.parentNode.insertBefore(li, li.parentNode.firstChild);
    if (els.headline && li.dataset.headline) els.headline.textContent = li.dataset.headline;
    state[key] = { v: 0, qty: 1 };
    lastKey = key;
    started = true; // a preloaded box isn't the visitor's own action
    li.classList.add('is-preload');
  }

  /* ---------- scroll reveal ---------- */
  function reveal() {
    var nodes = $$('.ss-reveal');
    if (!('IntersectionObserver' in window)) { nodes.forEach(function (n) { n.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    nodes.forEach(function (n, i) { n.style.transitionDelay = (i % 3) * 90 + 'ms'; io.observe(n); });
  }

  preload();
  render();
  reveal();
  track('ViewSellPage', { preload: new URLSearchParams(location.search).get('p') || '' }, { once: 'sellview' });
})();
